<template>
    <b-modal
        id="addSectionModal"
        @shown="focusMyElement"
        @close="onClose"
        v-model="sessionModal"
        :title="'Criador de páginas'"
        modal-class="bg-white"
        content-class="no-border"
        ok-title="Adicionar"
        cancel-title="Cancelar"
        no-close-on-esc
        hide-footer
        centered
        scrollable
    >
        <section class="newSection-modal">
            <div class="container-fluid p-0 m-0">
                <!-- Nome do novo menu -->
                <div v-if="showAllOptions" class="row no-gutters w-100">
                    <div class="col-12 col-md-5 d-flex flex-column">
                        <label
                            class="newSection-label text-muted"
                            for="newSectionName"
                        >
                            Nome da página
                        </label>
                        <input
                            v-model="newSession"
                            ref="focusThis"
                            id="newSection-input"
                            class="newSection-input"
                            name="newSectionName"
                            type="text"
                        />
                    </div>
                </div>

                <!-- Listagem de tipos de seções -->
                <div class="row no-gutters w-100">
                    <div class="col-12 p-0 m-0">
                        <template v-if="showAllOptions">
                            <b-tabs
                                class="mb-3"
                                active-nav-item-class="newSection-listItem--active"
                            >
                                <b-tab
                                    title-link-class="newSection-listItem"
                                    title-item-class="newSection-list"
                                    v-for="section in sections"
                                    :title="section.name"
                                    :key="section.name"
                                    @click="setActive(section)"
                                />
                            </b-tabs>
                        </template>
                        <template v-else-if="!showAllOptions">
                            <b-tabs
                                active-nav-item-class="newSection-listItem--active"
                            >
                                <b-tab
                                    title-link-class="newSection-listItem"
                                    title-item-class="newSection-list"
                                    v-for="section in filterDefaultSections"
                                    :title="section.name"
                                    :key="section.name"
                                    @click="setActive(section)"
                                />
                            </b-tabs>
                        </template>
                    </div>
                </div>

                <!-- Mostra os passos a serem seguidos -->
                <template v-if="active && active.steps">
                    <div class="newSection-steps">
                        <ul>
                            <li class="newSection-steps--item" v-for="(step, index) in active.steps" :key="index" @click="setStep(index)">
                                <p :class="[activeStep === index ? 'newSection-itemSteps--active' : 'newSection-itemSteps']">{{ step.message }}</p>
                            </li>
                        </ul>
                    </div>
                </template>

                <!-- Mensagem sobre criação de link externo  -->
                <template v-if="active && active.component == 'link'">
                    <div class="newSection-steps">
                        <ul>
                            <li class="newSection-steps--item">
                                <p class="newSection-itemSteps--active">Cria um link personalizado no menu do seu site</p>
                            </li>
                        </ul>
                    </div>
                </template>

                <!-- Listagem de combinações -->
                <div v-if="active && active.name != 'Página em branco'" class="container-fluid p-0 m-0">
                    <ul
                        class="newSection-cards row p-0 m-0 d-flex justify-content-start w-100 mx--3"
                    >
                        <template
                            v-for="combination in filterOrganisms()"
                        >
                            <div :key="combination.id" class="col-12 col-md-4 p-0">
                                <li
                                    class="type-section m-3 text-center"
                                    :class="lastOrganism && organism.includes(combination.id) && 'type-section-selected'"
                                    @click="setOrganism(combination.id)"
                                >
                                    <a
                                        class="newSection-card shadow-sm text-center"
                                    >
                                        <img class="img-fluid" v-bind:src="combination.picture" />
                                    </a>
                                </li>
                            </div>
                        </template>
                    </ul>
                </div>

                <!-- Opções para páginas em branco  -->
                <div v-else>
                    <div class="mb-4">
                        <p class="text-muted mb-0 font-12">Você pode criar uma página em branco ou começar com um layout predefinido escolhendo o tipo acima.</p>
                        <p class="text-muted mb-0 font-12">Caso queira uma página em branco, escolha abaixo se vai ser uma página com listagem de outras páginas (tipo blog, videos..) ou única (landing pages, sobre...)</p>
                    </div>

                    <ul class="newSection-cards row p-0 m-0 d-flex justify-content-start w-100 mx--3">
                        <div class="col-12 col-md-4 p-0">
                            <li
                                class="type-section m-3 text-center"
                                :class="lastOrganism == 'maincontent' ? 'type-section-selected' : ''"
                                @click="setOrganism('maincontent')"
                            >
                                <a class="newSection-card shadow-sm text-center">
                                    <img class="img-fluid" v-bind:src="'https://uli-pictures.s3.sa-east-1.amazonaws.com/pagina-unica.png'" />
                                </a>
                            </li>
                        </div>

                        <div class="col-12 col-md-4 p-0">
                            <li
                                class="type-section m-3 text-center"
                                :class="lastOrganism == 'blog' ? 'type-section-selected' : ''"
                                @click="setOrganism('blog')"
                            >
                                <a class="newSection-card shadow-sm text-center">
                                    <img class="img-fluid" v-bind:src="'https://uli-pictures.s3.sa-east-1.amazonaws.com/pagina-pastas.png'" />
                                </a>
                            </li>
                        </div>
                    </ul>
                </div>

                <!-- Botão adicionar  -->
                <div class="btn-wrapper row d-flex justify-content-center align-items-center w-100">
                    <div class="col-12 d-flex justify-content-center mt-5">
                        <button
                            :disabled="checkDisabled()"
                            class="btn btn-large btn-primario d-flex align-items-center"
                            @click="createNewSection(newSessionChoice, newCardIndex)"
                        >
                            Adicionar
                            <i v-if="loading" class="fal fa-spinner fa-spin fa-2x ml-2"></i>
                        </button>
                    </div>
                </div>
            </div>

            <error-modal :text="errorMessage" />
        </section>
    </b-modal>
</template>

<script>
import sectionsMixins from "@/mixins/sectionsMixins";
import apiMixins from "@/mixins/apiMixins";
import ErrorModal from "@/components/molecules/ErrorModal";

export default {
    name: "NewSection",
    components: {
        ErrorModal
    },
    data() {
        return {
            activeStep: 0,
            newSession: "",
            newSessionChoice: 0,
            newSessionTarget: 0,
            errorMessage: "",
            sessionModal: false,
            loading: false,
            listOrganisms: [],
            organism: [],
            lastOrganism: null,
            categories: [],
            sections: [
                {
                    name: "Página em branco",
                    default: false,
                    component: "maincontent",
                    options: { frames: ["text"] },
                    picture:
                        "https://uli-pictures.s3.sa-east-1.amazonaws.com/site-dashboard/newSectionUnicPage.png"
                },
                {
                    name: "Blog",
                    component: "blog",
                    default: false,
                    options: {},
                    steps: [
                        {
                            title: "Estilo da listagem",
                            message: "1º Escolha o layout do seu blog",
                            component: "blog"
                        },
                        {
                            title: "Estilo da galeria",
                            message: "2º Layout dos posts",
                            component: "maincontent"
                        }
                    ],
                    picture:
                        "https://uli-pictures.s3.sa-east-1.amazonaws.com/site-dashboard/newSectionBlog.png"
                },
                {
                    name: "Galerias diversas",
                    default: false,
                    component: "blog",
                    options: { galleryType: "isotope" },
                    steps: [
                        {
                            title: "Estilo da listagem",
                            message: "1º Escolha o layout da listagem",
                            component: "blog"
                        },
                        {
                            title: "Estilo da galeria",
                            message: "2º Layout das fotos",
                            component: "maincontent"
                        }
                    ],
                    picture:
                        "https://uli-pictures.s3.sa-east-1.amazonaws.com/site-dashboard/newGaleriaDiversas.png"
                },
                {
                    name: "Galeria única",
                    default: false,
                    component: "maincontent",
                    options: { frames: ["gallery"] },
                    picture:
                        "https://uli-pictures.s3.sa-east-1.amazonaws.com/site-dashboard/newSectionUnicGalery.png"
                },
                {
                    name: "Sobre",
                    component: "about",
                    default: true,
                    options: {},
                    picture:
                        "https://uli-pictures.s3.sa-east-1.amazonaws.com/site-dashboard/newSectionTextPlusImage.png"
                },
                {
                    name: "Formulário",
                    default: true,
                    component: "contact",
                    options: {},
                    picture:
                        "https://uli-pictures.s3.sa-east-1.amazonaws.com/site-dashboard/newSectionForm.png"
                },
                {
                    name: "Depoimentos",
                    default: true,
                    component: "comments",
                    options: {},
                    picture:
                        "https://uli-pictures.s3.sa-east-1.amazonaws.com/site-dashboard/newSectionComments.png"
                },
                {
                    name: "Newsletter",
                    default: true,
                    component: "newsletter",
                    options: {},
                    picture:
                        "https://uli-pictures.s3.sa-east-1.amazonaws.com/site-dashboard/newSectionNewsletter.png"
                },
                {
                    name: "Loja",
                    default: true,
                    component: "storelist",
                    options: {},
                    picture:
                        "https://uli-pictures.s3.sa-east-1.amazonaws.com/site-dashboard/newSectionStore.png"
                },
                {
                    name: "Link externo",
                    default: false,
                    component: "link",
                    default: false,
                    options: {},
                    picture:
                        "https://uli-pictures.s3.sa-east-1.amazonaws.com/site-dashboard/newSectionExternalLink.png"
                }
            ],
            active: null,
            combinations: []
        };
    },
    props: {
        newCardIndex: {
            type: Number,
            require: false
        },
        sectionsCategories: {
            type: Array,
            required: false,
        },
        postId: {
            required: false,
        },
        showAllOptions: {
            type: Boolean,
            required: false,
            default: true,
        },
        section: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    mixins: [apiMixins, sectionsMixins],
    created() {
        this.categories = this.sectionsCategories; // Categorias do site via props
        this.sessionModal = true; // Controla a exibição da modal
        this.fetchCombinations(); // Busca as combinações cadastradas na base de dados
    },
    watch: {
        sessionModal() {
            this.$emit("sessionModal", this.sessionModal);
        },
    },
    methods: {
        // Define o tipo de seção ativa no criador de página
        setActive(section) {
            this.active = section;
            this.organism = [];
            this.setStep(0);
        },
        // Define em qual passo da seção o usuário está
        setStep(step) {
            // mostra os organismos porem nao deixa o usuário avançar nos steps sem ter selecionado a primeira opção
            if (step > 0 && !this.organism[step -1]) {
                this.listOrganisms = this.combinations[this.active.component];
                return null;
            }

            this.activeStep = step;
            if (this.active.steps) {
                this.listOrganisms = this.combinations[this.active.steps[this.activeStep].component];
            } else {
                this.listOrganisms = this.combinations[this.active.component];
            }
        },
        // Adiciona o organismo selecionado no index de componentes
        setOrganism(combination) {
            this.organism[this.activeStep] = combination;
            if (this.active.steps && this.activeStep < (this.active.steps.length - 1)) {
                this.setStep(this.activeStep + 1);
            }
            this.lastOrganism = combination;
        },
        // Filtra os tipos de seções que serão usadas pelo criador de página
        getSections() {
            return this.sections.filter(item =>{
                return this.showAllOptions || (!this.showAllOptions && item.default);
            })
        },
        filterOrganisms() {
            if (!this.active) {
                return this.listOrganisms;
            } else if (this.active.component != 'blog' || this.activeStep != 1) {
                return this.listOrganisms;
            } else if (this.active.name == 'Galerias diversas') {
                return this.listOrganisms.filter(item => {
                    return !item.hasComments && !item.hasSidebar
                })
            } else {
                return this.listOrganisms.filter(item => {
                    return item.hasComments || item.hasSidebar
                })
            }
        },
        checkDisabled() {
            return !this.active 
                || this.loading 
                || (this.active.steps && this.organism.length < this.active.steps.length) 
                || (this.active.name != 'Página em branco' && this.combinations[this.active.component] && !this.organism[0]);
        },
        checkSelected(combination) {
            return this.organism[this.activeStep] == combination.id && 'type-section-selected';
        },
        onClose() {
            this.$emit("newCategories", this.categories);
        },
        async createNewSection(newSessionChoice, newCardIndex) {
            // Só valida erro se for criação de página
            var errors = false;
            if (this.section) {
                errors = this.verifyErrors();
            }
            
            // Se houve erro, exibe modal de aviso
            if (errors && this.errorMessage) {
                this.$bvModal.show("errorModal")
                return null;
            }

            // Se for criação de página e não houveram erros, inicia loading
            if (this.section && !errors) {
                this.$emit("newSessionLoading", true);
            }
            var section = this.active;
            var organism = this.organism;
            var component = section.component;

            if (organism[0] == 'blog' || organism[0] == 'maincontent') {
                component = organism[0];
            }

            // Faz requisição pra criar nova página/card
            var response = await this.handleNewSection(
                component,
                newCardIndex,
                section.options,
                organism
            );

            if (response) {
                this.onClose();
                // emite que criou uma sessao para fechar a modal
                this.$emit("sessioncreated", true);
                this.$emit("newSessionLoading", false);
                if (!this.showAllOptions) {
                    this.scrollToSection(response.id.frame);
                }
            }
        },
        async fetchCombinations() {
            const { message } = await this.requestApiData(
                "/template/organism/combination",
                "get"
            );

            if (message) {
                this.combinations = message;
                // this.listOrganisms = this.combinations.blog;
            }

            if (this.showAllOptions) {
                this.setActive(this.sections[0]);
            } else {
                this.setActive(this.filterDefaultSections[0]);
            }
        },
        focusMyElement(e) {
                if (this.section) {
                    this.$refs.focusThis.focus();
                }
            },
    },
    computed: {
        hasStore() {
            if (!this.categories) {
                return false;
            }
            return this.categories.some((category) => category.type == "store");
        },
        filterDefaultSections: function() {
            return this.sections.filter(section => section.default === true);
        },
    }
};
</script>

<style>
:root {
    --newSectionThemeColor: rgba(0, 0, 0, 0.2);
    --newSectionThemeColorHover: rgba(0, 0, 0, 0.4);
    --newSectionThemeColorActive: rgba(0, 0, 0, 0.8);
}

.newSection-steps .font-bold {
    font-weight: 700;
}

#addSectionModal .nav-tabs .nav-link {
    border: none;
}

#addSectionModal .mx--3 {
    margin: 0 -0.75rem!important;
}

#addSectionModal .modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width: 100%;
    max-height: 100%;
}

#addSectionModal .modal-content {
    width: 100%;
    height: 100%;
    border: none;
}

.newSection-label {
    color: var(--newSectionThemeColor);
    font-size: 0.625rem;
}

.newSection-input {
    border-width: 0px 0px 1px 0px;
    border-color: var(--newSectionThemeColor);
    border-style: solid;
}

.newSection-categories {
    padding: 0;
    margin: 0;
    max-width: 100%;
}

.newSection-categories,
.newSection-cards {
    list-style: none;
}

.newSection-listItem {
    position: relative;
    white-space: nowrap;
    text-decoration: none;
}

.newSection-listItem--active {
    color: var(--newSectionThemeColorActive) !important;
}

.newSection-itemSteps--active {
    font-weight: 700;
    color: var(--newSectionThemeColorActive);
}

.newSection-itemSteps {
    font-weight: 400;
    color: var(--newSectionThemeColor);
}

.newSection-listItem--active:after {
    content: " ";
    display: inline-block;
    width: 6px;
    height: 6px;
    position: relative;
    border-radius: 50px;
    background: var(--main-color);
    bottom: -0.975rem;
    left: -50%;
}

.newSection-list:first-of-type {
    padding-left: 0;
}

.newSection-list a {
    cursor: pointer;
    text-decoration: none;
    font-size: 0.875;
    color: var(--newSectionThemeColor);
    transition: 200ms ease-out;
}

.newSection-list a:hover {
    color: var(--newSectionThemeColorHover);
}

.newSection-info {
    color: var(--newSectionThemeColorHover);
    font-size: 0.875rem;
    margin-bottom: 1.5rem;
}

.newSection-info a {
    text-decoration: underline!important;
    color: #0d6efd!important;
    cursor: pointer;
}

.newSection-steps ul {
    display: flex;
    padding: 0 1rem;
    margin-bottom: 0;
    padding-left: 0;
    list-style-type: none;
    cursor: pointer;
}

.newSection-steps--item + .newSection-steps--item {
    margin-left: 2em!important;
}

.newSection-card {
    margin-bottom: 2rem;
    text-align: center;
}

#newSession {
    border: none;
    border-bottom: 1px solid #dddddd;
    border-radius: 0;
    width: 100%;
}
#newSession:focus {
    border-bottom: 1px solid var(--main-color);
    outline: none !important;
}

.btn-wrapper {
    position: fixed;
    bottom: 1rem;
}

.type-section {
    padding: 8px;
    border-radius: 5px;
    transition: all 300ms;
    border: 2px solid #e6e6fa;
}
.type-section p {
    margin-bottom: 0;
}
.type-section:hover {
    cursor: pointer;
    border: 2px solid var(--main-color);
}
.type-section-selected {
    cursor: pointer;
    border: 2px solid var(--main-color);
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/NewSection.vue